import request from "./http";

class PaymentOrderRepository
{
    async create(data) {
        const path = "payment-orders/create";
        const method = "POST";

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async edit(data) {
        const path = "payment-orders/edit";
        const method = "POST";

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("edit", error);
        }
    }

    async remove(data) {
        const path = "payment-orders/remove";
        const method = "POST";

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("edit", error);
        }
    }

    async getOneById(id) {
        const path = "payment-orders/get";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async getDetails(id) {
        const path = "payment-orders/details";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async getAll() {
        const path = "bank-accounts";
        const method = "GET";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async gridview(data) {
        const path = "payment-orders/gridview";
        const method = "POST";

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async payment(data) {
        const path = "payment-orders/payment";
        const method = "POST";

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async transfer(data) {
        const path = "payment-orders/transfer";
        const method = "POST";

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("post transfer", error);
        }
    }
}

export default PaymentOrderRepository;